//实现回到顶部效果
var oGo = document.querySelector(".gotop");//获取去顶部的元素
var timer = null;//把定时器置为空
oGo.onclick = function () {//点击事件 
    clearInterval(timer);//清除定时器
    timer = setInterval(function () {
        document.documentElement.scrollTop -= 100;//滚动条每次距离顶部的距离减10
        var oSt = document.documentElement.scrollTop;//获取滚动条距离顶部的距离
        // console.log(oSt);
        if (oSt === 0) {
            clearInterval(timer);//如果距离顶部距离为0 清除定时器
        }
    }, 20);
}
//实现吸顶效果
window.onscroll = function () {//滚动监听事件
    var oNav = document.querySelector(".announcement-bar");//获取announcement-bar元素
    var oSt = document.documentElement.scrollTop;//获取滚动条距离顶部的距离
    if (oSt >= 100) {
        oGo.style.display = "flex";//如果滚动条距离顶部的距离大于100 显示按钮
    } else {
        oGo.style.display = "none";//否则不显示
    }
}